import request from '@/api/request'

export function doPost (url, param) {
  return request({
    url: url,
    method: 'post',
    data: param
  })
}

export function doGet (url, param) {
  return request({
    url: url,
    method: 'get',
    params: param
  })
}

export function doPut (url, param) {
  return request({
    url: url,
    method: 'put',
    data: param
  })
}

export function doDelete (url, param) {
  return request({
    url: url,
    method: 'delete',
    data: param
  })
}
